"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnnouncementApi = void 0;

var _invoke = _interopRequireDefault(require("../../util/invoke"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {String} basePath
 * @param {String} authToken
 * @param {String} projectKey
 * @param {Number} page
 * @returns {Promise}
 */
const getAnnouncementApi = function getAnnouncementApi(basePath, authToken, projectKey) {
  let page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return (0, _invoke.default)({
    method: 'GET',
    url: "".concat(basePath, "/v2/notifications/list/announcement/?page=").concat(page),
    headers: {
      Authorization: "".concat(authToken),
      'platform-subscriber-id': projectKey
    }
  });
};

exports.getAnnouncementApi = getAnnouncementApi;